import { post, get } from "../index";
import EventRoutes from "./Event.routes";

const EventServices = {
  getAdvisionEvents: async (page, limit) => {
    const params = `?page=${page}&limit=${limit}`;
    const result = await get(EventRoutes.getAdvisionEvents + params);
    return result;
  },

  getDragonEvents: async (page, limit) => {
    const params = `?page=${page}&limit=${limit}`;
    const result = await get(EventRoutes.getDragonEvents + params);
    return result;
  },

  getEvents: async (page, limit) => {
    const result = await get(EventRoutes.getEvents + `?page=${page}&limit=${limit}`);
    return result;
  },

  sendEmail: async (obj) => {
    const result = await post(EventRoutes.sendEmail, obj);
    return result;
  }
};

export default EventServices;